import { NavLink } from "react-router-dom";
import { primaryNav } from "@/config/site";
import "./DesktopNav.css";

export function DesktopNav() {
  return (
    <nav className="desktop-nav" aria-label="Primary">
      <ul>
        {primaryNav.map((item) => (
          <li key={item.path}>
            <NavLink
              to={item.path}
              className={({ isActive }) => (isActive ? "is-active" : undefined)}
            >
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
